import {Component, Input, OnInit} from '@angular/core';
import {AllSidebarService} from "./all-sidebar.service";
import {environment} from "../../environments/environment";

@Component({
  standalone: false,
  selector: 'app-all-sidebar',
  templateUrl: './all-sidebar.component.html',
  styleUrls: ['./all-sidebar.component.css']
})
export class AllSidebarComponent implements OnInit {
  itemsShop: any;
  @Input() urlName: string;
  @Input() subUrlName: string;
  url: any;
  itemsShopList = [];

  constructor(private sidebarService: AllSidebarService,) {
    environment.then(environment => {
      this.url = environment["backendURL"];
      this.ngOnInit();
    });
  }

  ngOnInit(): void {
    this.sidebarService.getSidebarItems(this.url + '/' + this.urlName)
      .subscribe(response => {
        this.itemsShop = response;
        // console.log('length', this.itemsShop.length);
        for (let j = 0; j < this.itemsShop.length; j++) {
          let i;
          let item = this.itemsShop[j];
          if (j === 0) {
            this.itemsShopList.push({
              category: this.getCategory(item),
              subcategory: this.getAllSubcategory(this.getCategory(item))
            });
            // console.log('one', this.getAllSubcategory(this.getCategory(item)))
          }
          else {
            i = {
              category: this.getCategory(item),
              subcategory: this.getSubcaegory(item)
            };
            // console.log('two', i.subcategory);

            if (this.itemsShopList.findIndex((it) => it.subcategory === i.subcategory) < 0) {
              this.itemsShopList.push(i);
            }
          }
        }
        // console.log(this.itemsShop);
        if(this.itemsShopList.length > 1) {
          this.itemsShopList.sort((a, b) => a.subcategory.localeCompare(b.subcategory));
        }
      });
  }

  private getCategory(item) {
    if(item.subCategoryId.categoryByCategoryId.name.includes(' & ')) {
      item.subCategoryId.categoryByCategoryId.name = item.subCategoryId.categoryByCategoryId.name.replaceAll(' & ',"-and-");
    }
      return item.subCategoryId.categoryByCategoryId.name;
  }

  private getSubcaegory(item: any) {
      return item.subCategoryId.name.replace(' ', '-');
  }

  private getAllSubcategory(category: string) {
      return 'all-' + category;
  }
}
